/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Format_DoneInputs */



/**
* | output |
* | --- |
* | "Auto format completed" |
*
* @param {Context_Menu_Auto_Format_DoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_format_done = /** @type {((inputs?: Context_Menu_Auto_Format_DoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Format_DoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise en forme automatique terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierung abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione automatica completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование завершено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato automático completado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動フォーマットが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो फॉर्मेट पूरा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática concluída")
	return /** @type {LocalizedString} */ ("Auto format completed")
});